import { render, staticRenderFns } from "./composition.vue?vue&type=template&id=65b16006"
import script from "./composition.vue?vue&type=script&lang=js"
export * from "./composition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports